import React from 'react'
import { Link } from 'gatsby'
import styles from './navigation.module.scss'

export default ({ mobile, location }) => (
  <nav
    role="navigation"
    className={`${mobile === true ? styles.navMobWrap : ''}`}
  >
    <ul
      className={`${styles.navigation} ${mobile === true ? styles.navMob : ''}`}
    >
      <li
        className={
          location == '/'
            ? ` ${styles.navigationItem} heading ${styles.navigationItemIndex}`
            : `${styles.navigationItem}  heading`
        }
      >
        <Link
          activeClassName={
            location != '/'
              ? `${styles.activeClass}`
              : `${styles.activeClassHome}`
          }
          to="/"
        >
          Home
        </Link>
      </li>
      <li
        className={
          location == '/'
            ? ` ${styles.navigationItem} heading ${styles.navigationItemIndex}`
            : `${styles.navigationItem}  heading`
        }
      >
        <Link activeClassName={styles.activeClass} to="/coaches/">
          Coaches
        </Link>
      </li>
      <li
        className={
          location == '/'
            ? ` ${styles.navigationItem} heading ${styles.navigationItemIndex}`
            : `${styles.navigationItem}  heading`
        }
      >
        <Link activeClassName={styles.activeClass} to="/blog/">
          Blog
        </Link>
      </li>
      <li
        className={
          location == '/'
            ? ` ${styles.navigationItem} heading ${styles.navigationItemIndex}`
            : `${styles.navigationItem}  heading`
        }
      >
        <Link activeClassName={styles.activeClass} to="/contact/">
          Contact
        </Link>
      </li>
    </ul>
  </nav>
)
